import { render, staticRenderFns } from "./BannerViewer.vue?vue&type=template&id=32d1620a"
import script from "./BannerViewer.vue?vue&type=script&lang=js"
export * from "./BannerViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports